import img1 from "../assets/gallery/Scotland/scotland1.jpg";
import img2 from "../assets/gallery/Scotland/scotland2.jpg";
import img3 from "../assets/gallery/Scotland/scotland3.jpg";
import img4 from "../assets/gallery/Scotland/scotland4.jpg";
import img5 from "../assets/gallery/Scotland/scotland5.jpg";
import img6 from "../assets/gallery/Scotland/scotland6.jpg";
import img7 from "../assets/gallery/Scotland/scotland7.jpg";
import img8 from "../assets/gallery/Scotland/scotland8.jpg";
import img9 from "../assets/gallery/Scotland/scotland9.jpg";
import img10 from "../assets/gallery/Scotland/scotland10.jpg";
import img11 from "../assets/gallery/Scotland/scotland11.jpg";
import img12 from "../assets/gallery/Scotland/scotland12.jpg";
import img13 from "../assets/gallery/Scotland/scotland13.jpg";
import img14 from "../assets/gallery/Scotland/scotland14.jpg";
import img15 from "../assets/gallery/Scotland/scotland15.jpg";
import img16 from "../assets/gallery/Scotland/scotland16.jpg";

const scotlandGallery = [
  { img: img1, colSpan: 2, rowSpan: 2 }, // featured
  { img: img2 },
  { img: img3 },
  { img: img4 },

  { img: img5 },
  { img: img6, colSpan: 2 },
  { img: img7 },
  { img: img8 },
  { img: img9, colSpan: 2, rowSpan: 2 }, // featured

  { img: img10 },
  { img: img11 },
  { img: img12 },
  { img: img13, colSpan: 2 },
  { img: img14 },

  { img: img15 },
  { img: img16 },
];

export default scotlandGallery;
